import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import AccordionContent from '@stories/Components/General/AccordionContent/AccordionContent';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './FaqAccordion.styles';
const FaqAccordion = ({ accordion, title, variant, cta }) => {
    return (React.createElement(S.Container, null,
        React.createElement(SectionWrapper, { variant: variant ?? 'dark' },
            React.createElement(S.Grid, null,
                React.createElement(S.ContentArea, null,
                    title && React.createElement(S.Title, null, title),
                    React.createElement(AccordionContent, { key: `${title}-accordion`, items: accordion.items }),
                    cta && cta.text && (React.createElement(LinkButton, { branding: 'textOnly', href: cta.url, target: cta.target, title: cta.text })))))));
};
export default FaqAccordion;
